export enum FiscalYearsActionTypes {
  SET_FISCAL_YEARS = '@@fiscal-years/SET_FISCAL_YEARS',
}
